// src/UsersIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var UsersIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.15618 10.7812C8.96504 10.7812 10.8098 11.2356 12.2357 12.1872C13.5183 13.0405 14.2539 14.2369 14.2539 15.5244C14.2539 16.731 13.6088 17.8598 12.4722 18.703L12.2384 18.8679C10.808 19.8249 8.9601 20.2812 7.14976 20.2812C5.3393 20.2812 3.49065 19.8251 2.06017 18.8679C0.77906 18.0148 0.0447753 16.8183 0.0446777 15.5317C0.0446777 14.2447 0.778895 13.0459 2.06017 12.1881L2.06292 12.1863C3.49727 11.2353 5.34645 10.7813 7.15618 10.7812ZM7.15618 12.189C5.55938 12.1891 3.99681 12.5941 2.84107 13.3604C1.85336 14.0226 1.4525 14.8227 1.4525 15.5317C1.45259 16.1965 1.80474 16.9398 2.66326 17.5719L2.84198 17.6966L2.84382 17.6975C3.99419 18.4671 5.55355 18.8734 7.14976 18.8734C8.74597 18.8734 10.3053 18.4671 11.4557 17.6975C12.4453 17.0349 12.8461 16.234 12.8461 15.5244C12.8461 14.8151 12.4453 14.0172 11.4566 13.3595L11.4557 13.3586C10.3103 12.5937 8.75323 12.189 7.15618 12.189Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.8726 11.5484L15.944 11.5612L16.2208 11.63C16.8634 11.8049 17.4859 12.0836 18.0219 12.4915C18.9066 13.1551 19.4022 14.0808 19.4022 15.0588C19.4021 16.0366 18.9075 16.9625 18.0228 17.626L18.0219 17.6251C17.4019 18.0993 16.6655 18.4097 15.9046 18.5682C15.5242 18.6474 15.1509 18.4032 15.0715 18.0229C14.9923 17.6425 15.2366 17.2692 15.6168 17.1897C16.2045 17.0673 16.7416 16.834 17.1713 16.5042L17.1777 16.4996C17.757 16.0651 17.9943 15.5355 17.9944 15.0588C17.9944 14.5819 17.7571 14.0525 17.1777 13.6179L17.1731 13.6143C16.7547 13.2948 16.225 13.0673 15.6342 12.9342C15.2551 12.8486 15.0172 12.472 15.1026 12.0928C15.1828 11.7375 15.5186 11.5057 15.8726 11.5484Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.9496 2.15834C16.1604 2.15846 17.9384 3.9484 17.9384 6.14716C17.9384 8.30145 16.2293 10.0551 14.0981 10.1351C14.0602 10.1365 14.0221 10.1352 13.9845 10.1305C13.9704 10.1287 13.9417 10.1274 13.9056 10.1314C13.5193 10.1743 13.1714 9.89624 13.1284 9.50997C13.0855 9.12366 13.3635 8.77577 13.7498 8.73274C13.851 8.72152 13.9567 8.72065 14.0615 8.72724C15.4327 8.66733 16.5306 7.53498 16.5306 6.14716C16.5306 4.72329 15.3802 3.56628 13.9496 3.56616C13.5609 3.5661 13.2457 3.25097 13.2457 2.86225C13.2457 2.47353 13.5609 2.1584 13.9496 2.15834Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.99578 0.28125C9.68358 0.281716 11.8663 2.4648 11.8663 5.1527V5.15545C11.8553 7.78349 9.78328 9.92504 7.16901 10.0132C7.13796 10.0142 7.10644 10.0135 7.07552 10.0104C7.03037 10.0059 6.96247 10.0056 6.89954 10.0113C6.87075 10.0139 6.84136 10.0141 6.81247 10.0132C4.19856 9.9253 2.12454 7.78361 2.12433 5.1527C2.12433 2.46554 4.29717 0.28125 6.99578 0.28125ZM6.99578 1.68907C5.07675 1.68907 3.53214 3.24099 3.53214 5.1527C3.53236 7.02233 4.99974 8.53681 6.8473 8.60534C6.94046 8.59987 7.03748 8.59995 7.13051 8.60534C8.97806 8.53844 10.449 7.02482 10.4585 5.1527L10.4539 4.97398C10.3609 3.14624 8.84626 1.68952 6.99578 1.68907Z",
          fill: "currentColor"
        }
      )
    ]
  }
);

export {
  UsersIcon
};
